export const ActionTypes = {
    SET_STATS: 'landing/SET_STATS',
}